import { Reveal } from "@/components/motion";

const STEPS = [
  { num: "01", title: "Measure", body: "Understand your current ESG performance, data and risks." },
  { num: "02", title: "Understand", body: "Identify material issues, opportunities and areas for improvement." },
  { num: "03", title: "Transform", body: "Build the strategy, policies, capabilities and roadmap to move forward." },
];

export default function Approach() {
  return (
    <section className="bg-ink text-white sec" data-testid="approach-section">
      <div className="wrap">
        <Reveal>
          <h2 className="h-display font-bold text-[32px] sm:text-5xl lg:text-[56px] leading-[1.06] mb-16">
            Measure. Understand. <span className="text-gold">Transform.</span>
          </h2>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-10 lg:gap-14" data-testid="approach-steps">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.1}>
              <div className="border-t rule-dark pt-8 group">
                <p className="h-display font-bold text-[72px] sm:text-[88px] leading-none text-gold/25 group-hover:text-gold/60 transition-colors duration-500" data-testid={`approach-number-${s.num}`}>
                  {s.num}
                </p>
                <h3 className="h-display font-bold text-2xl mt-6 mb-3">{s.title}</h3>
                <p className="text-mute text-[14.5px] leading-relaxed max-w-xs">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
